import React from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import AppDateInput from '../../../components/input/app-date-input';
import AppSelectInput from '../../../components/input/app-select-input';
import {Column, Row} from '../../../components/layout';
import '../reimbursement-history/components/styles.scss';
import {strings} from '../../../util/strings';

export interface ClaimItemsFilterProps {
  allowFutureDates?: boolean;
  restrictDateInterval?: boolean; //Allow only periodFrom < periodTill
  filterParmOne?: string;
  filterParmTwo?: string;
  periodFrom?: Date;
  periodTill?: Date;
  filterParameterChanged(parameter: string, value: string): void;
  filterOneOptions: any[];
  filterTwoOptions?: any[];
  controlLabels: {[labelId: string]: string};
  filtersHaveChanged: boolean;
  labels?: typeof strings.pt.preAuthorizations;
}

function ClaimsItemFilter({
  allowFutureDates,
  restrictDateInterval,
  filterParmOne,
  filterParmTwo,
  periodFrom,
  periodTill,
  filterParameterChanged,
  filterOneOptions,
  filterTwoOptions,
  controlLabels,
  labels,
}: ClaimItemsFilterProps) {
  const minDate = restrictDateInterval ? periodFrom : undefined;
  const maxDate = restrictDateInterval ? periodTill : undefined;

  return (
    <Row
      className="reimbursement-history-container filter-modal-container reimbursement-history-bgbox"
      style={{
        background: 'linear-gradient(180deg, #F9F9F9 0%, #F0F0F0 100%)',
        display: 'flex',
        justifyContent: 'center',
      }}>
      {filterOneOptions !== undefined && filterOneOptions.length > 0 ? (
        <Column className="reimbursement-history-selectbox">
          <small className="reimbursement-history-label">
            {controlLabels['filterParmOne']
              ? controlLabels['filterParmOne']
              : ' '}
          </small>
          <AppSelectInput
            placeholder={labels?.refund_all_option}
            value={filterParmOne}
            onChange={(value) => {
              filterParameterChanged('filterParmOne', value);
            }}
            options={filterOneOptions}></AppSelectInput>
        </Column>
      ) : (
        ' '
      )}
      {filterTwoOptions !== undefined && filterTwoOptions.length > 0 ? (
        <Column className="reimbursement-history-selectbox">
          <small className="reimbursement-history-label">
            {controlLabels['filterParmTwo']
              ? controlLabels['filterParmTwo']
              : ' '}
          </small>
          <AppSelectInput
            placeholder={labels?.refund_all_option}
            value={filterParmTwo}
            onChange={(value) => filterParameterChanged('filterParmTwo', value)}
            options={filterTwoOptions}></AppSelectInput>
        </Column>
      ) : (
        ' '
      )}
      <Row>
        <Column className="reimbursement-history-dateinput">
          <small className="reimbursement-history-label">
            {controlLabels['filterDateFrom']
              ? controlLabels['filterDateFrom']
              : '\u00A0'}
          </small>
          <AppDateInput
            maxDate={maxDate}
            value={periodFrom}
            selected={periodFrom}
            onChange={(value) => {
              filterParameterChanged('periodFrom', value);
            }}></AppDateInput>
        </Column>
        <Column className="reimbursement-history-dateinput">
          <small className="reimbursement-history-label">
            {controlLabels['filterDateTo']
              ? controlLabels['filterDateTo']
              : '\u00A0'}
          </small>
          <AppDateInput
            minDate={minDate}
            maxDate={allowFutureDates ? undefined : new Date()}
            value={periodTill}
            selected={periodTill}
            onChange={(value) => {
              filterParameterChanged('periodTill', value);
            }}></AppDateInput>
        </Column>
      </Row>
    </Row>
  );
}

const mapStateToProps = ({strings}: any) => ({
  labels: strings.value.pt.preAuthorizations,
});

export default compose(connect(mapStateToProps)(ClaimsItemFilter));
